<script setup lang="ts">
  import { onMounted, nextTick, ref, onBeforeUnmount, watch, type WatchHandle } from 'vue';
  import { useHttpClient, useLocation } from '@othercommerce/foundation';
  import { usePageEditing, useCookieConsent } from '@storefront/storefront';

  defineOptions({
    inheritAttrs: false,
  });

  const http = useHttpClient();
  const location = useLocation();
  const editing = usePageEditing();
  const cookies = useCookieConsent();
  const watcher = ref<WatchHandle>();

  onMounted(() => {
    if (window.top && window.self !== window.top) {
      let origin = null;

      try {
        origin = window.top.origin;
      } catch (e) {
        console.warn('Blocked editor events by the Same-Origin policy:', e);
        return;
      }

      if (window.self.origin !== origin) {
        console.warn('Blocked editor events by the Same-Origin policy.');
        return;
      }

      watcher.value = watch(editing, (value) => {
        nextTick(() => {
          if (window.top) {
            window.top.postMessage({ command: 'EDITOR_REFRESH_PAGE', page: value, location: location.value });
          }
        });
      });

      window.addEventListener('message', (event) => {
        if (event.origin === window.self.origin) {
          if (event.data.command === 'EDITOR_REFRESH_VIEW') {
            nextTick(() => {
              http.dispatch('GET', window.location.href, { preserveScroll: true, replace: true });
            });
          }
        }
      });
    }
  });

  onMounted(() => {
    cookies.run();
  });

  onBeforeUnmount(() => {
    if (watcher.value) {
      watcher.value.stop();
    }
  });
</script>
<template>
  <slot />
  <AppConfirmationController />
  <AppPasswordConfirmController />
  <AppToastController />
  <AppProgressController />
  <AppNotificationsController />
  <AppInstallPrompt />
</template>
